import { AccountOrderDetailSkeleton } from "@/components/account/orders/detail/skeleton"

export default function Loading() {
  return <AccountOrderDetailSkeleton />
}
